module.exports = __webpack_public_path__ + "static/media/photo_034.585ecc84.JPG";